import setTeamSettings from "../actions/setTeamSettings";
import { orchestrator } from "satcheljs";
import { setTeamDetails } from "sh-team-store";

export default orchestrator( setTeamDetails, async actionMessage => {
    const teamDetails = actionMessage.teamDetails;
    setTeamSettings(teamDetails.teamSettings);
});